import {connect} from 'react-redux';
import React, {Component} from 'react';
import ReactModal from 'react-modal';
import {createExternalCalendar} from "../../actions/ExternalCalendars";

class ImportCalendarModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            name: ''
        }
    }

    handleInputChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    onClose(event) {
        event.preventDefault();

        this.props.onClose();
    }

    createExternalCalendar() {
        const externalCalendarCreateCommand = {
            objectId: this.props.objectId,
            url: this.url.value,
            name: this.name.value
        };
        this.props.createExternalCalendar(externalCalendarCreateCommand);

        this.props.onClose();
    }

    render() {
        let i18n = this.props.i18n;

        return (
            <ReactModal
                className="custom-react-modal external-calendars-modal"
                isOpen={this.props.isOpen}
                overlayClassName="custom-react-modal-overlay"
            >
                <form className="light">
                    <div className="external-calendars-modal_close">
                        <i className="fa fa-close" onClick={::this.onClose}/>
                    </div>

                    <div className="external-calendars-modal_title">
                        {i18n['creatingObjectPage.theCalendar.addCalendar.title']}
                    </div>

                    <div className="external-calendars-modal_form">
                        <label>
                            {i18n['creatingObjectPage.theCalendar.addCalendar.name']}:
                            <input
                                name="name"
                                value={this.state.name}
                                onChange={::this.handleInputChange}
                                ref={input => {
                                    this.name = input;
                                }}
                            />
                        </label>

                        <label>
                            {i18n['creatingObjectPage.theCalendar.addCalendar.url']}:
                            <input
                                name="url"
                                value={this.state.url}
                                onChange={::this.handleInputChange}
                                ref={input => {
                                    this.url = input;
                                }}
                            />
                        </label>
                    </div>

                    <br/>
                    <button className="btn" onClick={::this.createExternalCalendar}>
                        {i18n['creatingObjectPage.theCalendar.addCalendar.add']}
                    </button>
                </form>
            </ReactModal>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectId: state.creatingObjectPage.createdObject.id
});
const mapDispatchToProps = {
    createExternalCalendar
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportCalendarModal);


// WEBPACK FOOTER //
// ./src/components/CreatingProperty/ImportCalendarModal.js